export enum GeneralJournalRuleFieldType {
Account,
Collection,
Amount,
Text,
Date,
Currency,
Boolean,
}
